var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutlineIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 116,
    viewBox: "0 0 95 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.9454 115H54.9448H46.472H46.4703C41.397 115.008 36.3717 114.017 31.6821 112.081C26.9925 110.145 22.7305 107.304 19.1401 103.72C15.5497 100.135 12.7012 95.8781 10.7578 91.1918C8.8143 86.5054 7.81396 81.4818 7.81396 76.4084V70.5991H93.4448L93.5585 76.4181C93.5573 81.4846 92.5584 86.5012 90.6189 91.1818C88.6781 95.8653 85.8335 100.121 82.2477 103.704C78.6619 107.288 74.405 110.13 69.7204 112.069C65.0357 114.007 60.0151 115.003 54.9454 115ZM54.9448 116H46.472H54.9448Z",
    fill: "#FFCC00",
    stroke: "#082C4E",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9762 76.497C-1.54741 30.939 -1.65831 4.32286 4.59649 1.77214C22.1853 -5.50294 30.9908 40.2325 38.4434 71.6174C39.7298 57.8213 46.2951 38.5024 53.9695 40.2325C65.8358 42.9163 59.6476 69.2663 59.7585 74.3899C72.8669 43.5817 79.7206 42.6501 83.5799 44.5354C90.234 47.7737 81.7168 69.3106 75.9721 78.4932",
    stroke: "#082C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineIcon2);
export default __webpack_public_path__ + "static/media/outline-icon2.83dc2157b81234e65a5a261ba2432610.svg";
export { ForwardRef as ReactComponent };